import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import styles from "./chakra.module.css";
import Head from "next/head";
import Image from 'next/image';
import NewiconA from "../../assets/images/header/pdf-download1.png";
import Link from "next/link";
//import Upsdelhibanner from "../../assets/images/upsc/Chakra-web-banner.jpg";
//import MobUpscdelhibanner from "../../assets/images/upsc/Chakra-Mob-banner.jpg";
import Currentaffairs_form from "./currentaffairs.form";


export default function index() {
  const chakra =[
    {list:" Offline @Annanagar & branch Online."},  
    {list:" Regular Batch Days: Monday to Friday"},
    //{list:" 8 Total tests (6 monthly CA Tests +2 Mock Tests) "},
    
  ]
  return (
    <>
    <Head>
   
                <meta charset="UTF-8" />
                
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                <meta name="robots" content="noodp,noydir" />
                <meta name="robots" content="index,follow" />
                <meta name="robots" content="index,follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
                <meta property="article:publisher" content="https://www.facebook.com/shankariasacademy" />
                <meta property="article:modified_time" content="2024-01-25T05:43:44+00:00" />
                <title>Chakra UPSC Current Affairs | Shankar IAS Academy</title>
                <meta name="title" content="Chakra UPSC Current Affairs | Shankar IAS Academy" />
                <meta name="description" content=" Chakra UPSC Current Affairs Prelims and Mains: Daily insights, analysis, and key updates to help you excel in both Prelims and Mains exam preparation." />
                <link rel="canonical" href="https://www.shankariasacademy.com/current-affairs-upsc/" />
                <meta property="og:locale" content="en_US" />
                <meta property="og:type" content="website" />
                <meta property="og:title" content="Chakra UPSC Current Affairs | Shankar IAS Academy" />
                <meta property="og:description" content=" Chakra UPSC Current Affairs Prelims and Mains: Daily insights, analysis, and key updates to help you excel in both Prelims and Mains exam preparation." />
                <meta property="og:url" content="https://www.shankariasacademy.com/current-affairs-upsc/" />
                <meta property="og:site_name" content="Shankar IAS Academy" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:site" content="@shankarias" />
    </Head>
    <Navbar />
    <div className="container pt-3 ">
       <div className="rows pt-3 pb-3">
          <h1 className={`${styles.heading3d}`}>Chakra Current Affairs Programme 2026</h1>
      </div>
    </div>

  {/*  <div className="container">
        <div className="row d-none d-md-block">
            <div className="col mb-3">
              <Image
               src={Upsdelhibanner}  
                alt=""
                title="UPSC orientation Test Series 2024"
                className="img-fluid w-100"
              />
            </div>
          </div>

          <div className="row d-block d-md-none">
          <div className="col mb-3">
              <Image
                src={MobUpscdelhibanner}
                alt=""
                title="UPSC orientation"
                className="img-fluid w-100"
              />
            </div>
          </div>
    </div> */}

    <div className="container pt-3 pb-2 ">
    <div className="row">

      <div className="col-12 col-lg-6 " style={{background: "#F4F6F8 0% 0% no-repeat padding-box" , opacity: "1"}}>
        <div className="container"> 
          <div className="row">
              <div className="col-12 col-xl-6 pt-3">
                    <div className={`${styles.facultyborder1}  h-100`}>
                        <div className="row pt-3 pb-3">
                            <div className="col-7 col-xl-6 offset-xl-2">
                                <span className={`${styles.from}`}>Start from:</span><br />
                                <span className={`${styles.dateValue}`}>09<sup>th</sup></span><br />
                                <span className={`${styles.monValue}`}>Mar 2026</span>
                            </div>
                            <div className="col-5 col-xl-4 pt-3 pt-xl-0">
                              <Image src="/images/icon/Calender-01.png" alt="clendar" width={50} height={50} />
                            </div>
                        </div>
                    </div>
              </div>

              <div className="col-12 col-xl-6 pt-3">
                <div className={`${styles.facultyborder1} h-100`}>
                  <div className="row pt-3 pb-3">
                    <div className="col-7 col-xl-6 offset-xl-2">
                        <span className={`${styles.from}`}>Timings:</span><br />
                        <span className={`${styles.timeValue} `}>05:30 pm - 08:00 pm</span><br /> 
                    </div>
                    <div className="col-5 col-xl-4 pt-3 pt-xl-0">
                      <Image src="/images/icon/clock-01.png" alt="clendar" width={50} height={50} />
                    </div>
                  </div>
                </div> 
              </div>

              <div className="col-12 col-xl-8 offset-xl-2 pt-4">
                  <div className={`${styles.facultyborder1} h-100`}>    
                    <div className="row pt-3 pb-3">
                        <div className="col-7 col-xl-6  offset-xl-2">   
                            <span className={`${styles.from}`}>Fees: ₹ 2000</span><br />
                            <span className={`${styles.dayValue}`}></span> <br /> 
                        </div>
                        <div className="col-5 col-xl-4  pt-xl-0">
                            <span><a target="_blank" href="https://admissionsv1.shankariasacademy.com/?center=ANNA_NAGAR&coursetype=CHAKRA"><button class={`${styles.normalbutton}`} type="submit">Pay Here</button></a></span>
                        </div>
                    </div>
                  </div>
                </div>
          </div>
            <div className="container">
                <div className="row">
                  <div className="col-12 col-xl-12 pt-3">
                      <h2 className={`${styles.Feature} pt-3 mb-0`} >Features</h2>
                        <ul className={`${styles.ulclass} ps-1 pt-2`}>
                            {chakra.map((item,index)=>(
                            <li
                                  className={`${styles.ulliclass} ${styles.acheiverrank}`}
                                  id={styles.acheiverrankspecial} key={index}
                                  >
                                <div className="d-inline">
                                    <p className={`${styles.ullispan} d-inline`}>
                                    {item.list}
                                    </p>
                                </div>
                            </li>
                            ))}
                        </ul>
                  </div>
                  {/* <div className="col-12 col-xl-6 text-center pt-5"><a style={{color:"#000",fontSize:"18px"}} href="/pdf/Chakra/Chakra-CurrentAffairs-Brochure-2024.pdf" target="_blank"><Image src={NewiconA} alt="download icon"  className={`${styles.downloadicon}`}/><br />Click Here Schedule</a></div> */}
                </div>
            </div>
        </div> 
      </div>

      <div className="col-12 col-lg-6 ">
        <Currentaffairs_form/>
      </div>
  </div>
  </div>

  <div className="container pt-3 pb-2 ">
    <div className="rows pt-3 pb-3">
      <h2 className={`${styles.sectiontitlesub}`}><b>Chakra – Subject-wise General Studies Revision and Current Affairs</b></h2>
    </div>
  </div>

 

  <section className=" pb-3" style={{background: "" , opacity: "1"}}>
      <div className="container mt-2 mb-5">
          <div className="col-12 offset-xl-2 col-xl-8">   
          <div className="row">
      
          <div class=" col-12 col-xl-12 d-block " style={{backgroundColor:"#f4f6f8"}}>
            <div class="py-2" style={{backgroundColor: "#001e62"}}><h2 className={`${styles.tabletitle}`}>Chakra – Subject-wise Revision + Current Affairs Schedule</h2></div>
                  <div class="row border-bottom">
                        <div class={`${styles.tableheading} col-12 col-md-5 d-none d-md-block`} style={{color:"#DB1B0D"}}>Optional Subject</div>
            <div class={`${styles.tableheading} col-12 col-md-5 d-none d-md-block `} style={{color:"#DB1B0D"}}>DATE </div>   
          </div>

                  <div className="row border-bottom pt-3 ">
                      <div class="col-6 pt-3 d-block d-md-none" style={{color:"#DB1B0D"}}>Optional Subject</div>
                      <div class="col-6 pt-3 col-md-5"><b>Current Affairs revision</b></div>
                        <div class="col-6 pt-3 d-block d-md-none" style={{color:"#DB1B0D"}}>Date</div>
                      <div class="col-6 pt-3 col-md-5"><b>9th Mar - 13th Mar</b></div>
                                      
                  </div>
                  <div className="row border-bottom pt-3 ">
                      <div class="col-6 pt-3 d-block d-md-none" style={{color:"#DB1B0D"}}>Optional Subject</div>
                      <div class="col-6 pt-3 col-md-5"><b>Polity </b></div>
                      <div class="col-6 pt-3 d-block d-md-none" style={{color:"#DB1B0D"}}>Date</div>
                      <div class="col-6 pt-3 col-md-5"><b>16th Mar -20th Mar & 23rd Mar - 24th Mar</b></div>
                                      
                  </div>
                  <div className="row border-bottom pt-3 ">
                      <div class="col-6 pt-3 d-block d-md-none" style={{color:"#DB1B0D"}}>Optional Subject</div>
                      <div class="col-6 pt-3 col-md-5"><b>Modern India</b></div>
                      <div class="col-6 pt-3 d-block d-md-none" style={{color:"#DB1B0D"}}>Date</div>
                      <div class="col-6 pt-3 col-md-5"><b>25rd Mar - 27th Mar</b></div>
                                      
                  </div>
                    <div className="row border-bottom pt-3 ">
                      <div class="col-6 pt-3 d-block d-md-none" style={{color:"#DB1B0D"}}>Optional Subject</div>
                      <div class="col-6 pt-3 col-md-5"><b>Ancient,Medieval History and A&C</b></div>
                      <div class="col-6 pt-3 d-block d-md-none" style={{color:"#DB1B0D"}}>Date</div>
                      <div class="col-6 pt-3 col-md-5"><b>	30th Mar - 3rd April</b></div>
                                      
                  </div>
                  <div className="row border-bottom pt-3 ">
                      <div class="col-6 pt-3 d-block d-md-none" style={{color:"#DB1B0D"}}>Optional Subject</div>
                      <div class="col-6 pt-3 col-md-5"><b>Economics</b></div>
                      <div class="col-6 pt-3 d-block d-md-none" style={{color:"#DB1B0D"}}>Date</div>
                      <div class="col-6 pt-3 col-md-5"><b>6th April - 10th April & 13th April to 14th April</b></div>
                                      
                  </div>
    <div className="row border-bottom pt-3 ">
                      <div class="col-6 pt-3 d-block d-md-none" style={{color:"#DB1B0D"}}>Optional Subject</div>
                      <div class="col-6 pt-3 col-md-5"><b>Geography</b></div>
                      <div class="col-6 pt-3 d-block d-md-none" style={{color:"#DB1B0D"}}>Date</div>
                      <div class="col-6 pt-3 col-md-5"><b>15th April to 21st April</b></div>
                                      
                  </div>
  <div className="row border-bottom pt-3 ">
                      <div class="col-6 pt-3 d-block d-md-none" style={{color:"#DB1B0D"}}>Optional Subject</div>
                      <div class="col-6 pt-3 col-md-5"><b>Environment</b></div>
                      <div class="col-6 pt-3 d-block d-md-none" style={{color:"#DB1B0D"}}>Date</div>
                      <div class="col-6 pt-3 col-md-5"><b>22nd April to 24th April</b></div>
                                      
                  </div>
                <div className="row border-bottom pt-3 ">
                      <div class="col-6 pt-3 d-block d-md-none" style={{color:"#DB1B0D"}}>Optional Subject</div>
                      <div class="col-6 pt-3 col-md-5"><b>Science & Technology</b></div>
                      <div class="col-6 pt-3 d-block d-md-none" style={{color:"#DB1B0D"}}>Date</div>
                      <div class="col-6 pt-3 col-md-5"><b>27th April to 30th April</b></div>
                                      
                  </div>   
                    <div className="row border-bottom pt-3 ">
                      <div class="col-6 pt-3 d-block d-md-none" style={{color:"#DB1B0D"}}>Optional Subject</div>
                      <div class="col-6 pt-3 col-md-5"><b>International Organizations</b></div>

                        <div class="col-6 pt-3 d-block d-md-none" style={{color:"#DB1B0D"}}>Date</div>
                      <div class="col-6 pt-3 col-md-5"><b>4th May to 5th May</b></div>
                                      
                  </div>      

                                    
          </div>
          </div>
          </div>
      </div>
  </section> 



{/* <section className="pt-md-3 pt-lg-4" style={{background: "#F4F6F8 0% 0% no-repeat padding-box" , opacity: "1"}}>
    <div className="container mt-5 mb-5">
        <div className="col-12 col-xl-8 offset-xl-2">   
        <div className="row">
     
        <div class=" col-12 col-xl-12 " style={{backgroundColor:"#f4f6f8"}}>
          <div class="py-2" style={{backgroundColor: "#001e62"}}><h2 className={`${styles.tabletitle}`}>Schedule from 1st April 2024 to 26th April 2024</h2></div>
                    <div class="row border-bottom">
								<div class={`${styles.tableheading} col-12 col-md-4 d-none d-md-block`}>Days</div>
								<div class={`${styles.tableheading} col-12 col-md-4 d-none d-md-block`}>Timing</div>
								<div class={`${styles.tableheading} col-12 col-md-4 d-none d-md-block`}>Subject</div>			
					</div>
                 
                <div className="row border-bottom pt-3 pb-3">
                    <div class="col-6 pt-3 d-block d-md-none">Days</div>
                    <div class="col-6 pt-3 col-md-4"><b>Monday</b></div>
                    <div class="col-6 pt-3 d-block d-md-none">Timing</div>
                    <div class="col-6 pt-3 col-md-4">10 am - 01 pm</div>
                    <div class="col-6 pt-3 d-block d-md-none">Subject</div>			
                    <div class="col-6 pt-3 col-md-4">Indian Economy</div> 
                </div> 
                <div class="row border-bottom pt-3 pb-3">
                    <div class="col-6 d-block d-md-none">Days</div>
                    <div class="col-6 col-md-4 pt-3 pb-3"><b>Tuesday</b></div>
                    <div class="col-6 d-block d-md-none">Timing</div>
                    <div class="col-6 col-md-4 pt-3 pb-3">10 am - 01 pm</div>
                    <div class="col-6 d-block d-md-none">Subject</div>			
                    <div class="col-6 col-md-4  pt-3 pb-3">Science & Tech</div> 
                </div>  

                <div class="row border-bottom">
                    <div class="col-6 d-block d-md-none">Days</div>
                    <div class="col-6 col-md-4 pt-3 pb-3"><b>Wednesday</b></div>
                    <div class="col-6 d-block d-md-none">Timing</div>
                    <div class="col-6 col-md-4 pt-3 pb-3">10 am - 01 pm</div>
                    <div class="col-6 d-block d-md-none">Subject</div>			
                    <div class="col-12 col-md-4  pt-3 pb-3">Geography & Places In News</div> 
                </div> 

                <div class="row border-bottom">
                    <div class="col-6 d-block d-md-none">Days</div>
                    <div class="col-6 col-md-4 pt-3 pb-3"><b>Thursday</b></div>
                    <div class="col-6 d-block d-md-none">Timing</div>
                    <div class="col-6 col-md-4 pt-3 pb-3">10 am - 01 pm</div>
                    <div class="col-6 d-block d-md-none">Subject</div>			
                    <div class="col-6 col-md-4  pt-3 pb-3">Indian Polity</div> 
                </div>

                <div class="row border-bottom">
                    <div class="col-6 d-block d-md-none">Days</div>
                    <div class="col-6 col-md-4 pt-3 pb-3"><b>Friday</b></div>
                    <div class="col-6 d-block d-md-none">Timing</div>
                    <div class="col-6 col-md-4 pt-3 pb-3">10 am - 01 pm</div>
                    <div class="col-6 d-block d-md-none">Subject</div>			
                    <div class="col-6 col-md-4  pt-3 pb-3">Environment</div> 
                </div>

                <div class="row border-bottom">
                    <div class="col-6 d-block d-md-none">Days</div>
                    <div class="col-6 col-md-4 pt-3 pb-3"><b>Saturday</b></div>
                    <div class="col-6 d-block d-md-none">Timing</div>
                    <div class="col-6 col-md-8 pt-3 pb-3">50 Question Test On The Discussed Topics</div>
                    <div class="col-6 d-block d-md-none">Subject</div>			
                    
                </div>
                                  
	    </div>
        </div>
        </div>
        </div>
</section> */}


    <Footer />
    </>
  )
}
